<template>
    <div>
        <span class="section-title">{{ lang.predict_result }}</span>
        <message-component v-if="showError" :status="errorStatus" :message="errorMessage"></message-component>
        <div class="prediction-results" v-if="userPredicted && ! isLoading">
            <span class="bars clearfix">
                <span class="bar bar-1" :style="'width: ' + prediction['home']['bar-width'] + '%;'"></span>
                <span class="bar bar-2" :style="'width: ' + prediction['draw']['bar-width'] + '%;'"></span>
                <span class="bar bar-3" :style="'width: ' + prediction['away']['bar-width'] + '%;'"></span>
            </span>
            <span class="labels clearfix">
                <span class="label label-1" :style="'width: ' + prediction['home']['bar-width'] + '%;'">
                    <img v-if="typeof fixture !== 'undefined' && typeof fixture.home_team !== 'undefined'" :src="fixture.home_team.logo_path">
                    <img v-else src="../../images/logos/clubs/club-blank.svg">
                    {{ prediction['home']['value'] }}%
                </span>
                <span class="label label-2" :style="'width: ' + prediction['draw']['bar-width'] + '%;'">{{ prediction['draw']['value'] }}%</span>
                <span class="label label-3" :style="'width: ' + prediction['away']['bar-width'] + '%;'">
                    <img v-if="typeof fixture !== 'undefined' && typeof fixture.away_team !== 'undefined'" :src="fixture.away_team.logo_path">
                    <img v-else src="../../images/logos/clubs/club-blank.svg">
                    {{ prediction['away']['value'] }}%
                </span>
            </span>
        </div>
        <div class="prediction" v-else-if="! isLoading">
            <ul class="clearfix">
                <li><input type="radio" name="predict" id="predict-home" value="home" v-model="userPrediction"><label for="predict-home">{{ typeof fixture !== 'undefined' && typeof fixture.home_team !== 'undefined' ? fixture.home_team.short_name : lang.home }}</label></li>
                <li><input type="radio" name="predict" id="predict-draw" value="draw" v-model="userPrediction"><label for="predict-draw">{{ lang.draw }}</label></li>
                <li><input type="radio" name="predict" id="predict-away" value="away" v-model="userPrediction"><label for="predict-away">{{ typeof fixture !== 'undefined' && typeof fixture.away_team !== 'undefined' ? fixture.away_team.short_name : lang.away }}</label></li>
            </ul>
        </div>
        <div :class="{'is-loading is-loading-dark': isLoading}"></div>
    </div>
</template>

<script>
    import axios from 'axios'
    import MessageComponent from './MessageComponent.vue'
    export default {
        props: ['fixture_id', 'lang'],
        data() {
            return {
                isLoading: true,
                showError: false,
                errorStatus: 'generic',
                errorMessage: '',
                fixture: null,
                prediction: [],
                userId: null,
                userPredicted: false,
                userPrediction: '',
            }
        },
        computed: {
        },
        mounted() {
            this.showError = false;
            this.$nextTick(function () {
                axios.get('/api/prediction/' + this.fixture_id).then((response) => {
                    this.isLoading = false;
                    this.prediction = response.data.prediction;
                    this.userPredicted = response.data.predicted;
                    this.userId = response.data.userId;
                    this.fixture = response.data.fixture;
                }).catch((e) => {
                    this.isLoading = false;
                    this.errorStatus = 'error';
                    this.errorMessage = this.lang.error;
                    this.showError = true;
                });
            });
        },
        watch: {
            userPrediction: function(val) {
                let options = ['home', 'away', 'draw'];
                for (var i = 0; i < options.length; i++) {
                    if (options[i] == val) {
                        this.isLoading = true;
                        axios.post('/api/prediction/' + this.fixture_id, {
                            user_id: this.userId,
                            result: val
                        }).then((response) => {
                            this.isLoading = false;
                            this.userPredicted = true;
                            this.prediction = response.data.prediction;
                            this.userId = response.data.userId;
                            this.fixture = response.data.fixture;
                        }).catch(() => {
                            this.isLoading = false;
                            this.errorStatus = 'error';
                            this.errorMessage = this.lang.error;
                            this.showError = true;
                        });
                    }
                }
            }
        }
    }
</script>
